module.exports = __webpack_public_path__ + "img/home-bg1.6d659514.png";